module.exports = __webpack_public_path__ + "img/htcm_15.907f9614.jpg";